/**
 * Renderer-side API for notebook file operations (save/open .ipynb).
 *
 * Uses optional chaining for browser-mode compatibility.
 * Follows the same pattern as notebookSessionApi.ts.
 */

type SaveNotebookRequest = {
  content: string;
  filePath?: string;
  forceDialog?: boolean;
  suggestedFileName?: string;
};

type SaveNotebookResult =
  | { success: true; filePath: string }
  | { success: false; error: string; cancelled?: boolean };

type OpenNotebookRequest = {
  filePath?: string;
};

type OpenNotebookResult =
  | { success: true; filePath: string; content: string }
  | { success: false; error: string; cancelled?: boolean };

export async function saveNotebookFile(request: SaveNotebookRequest): Promise<SaveNotebookResult> {
  const result = await window.electronAPI?.notebookFile?.save(request);
  if (!result) {
    return { success: false, error: 'Notebook file save not available' };
  }
  return result;
}

export async function openNotebookFile(request?: OpenNotebookRequest): Promise<OpenNotebookResult> {
  const result = await window.electronAPI?.notebookFile?.open(request);
  if (!result) {
    return { success: false, error: 'Notebook file open not available' };
  }
  return result;
}
